"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnauthorisedStatsAccessError = void 0;
const client_library_1 = require("@seneca/client-library");
/**
 * Throw when user is unauthorised to access endpoint
 */
class UnauthorisedStatsAccessError extends client_library_1.ExtendableError {
    constructor() {
        super('You are not authorised to access this stats endpoint');
    }
}
exports.UnauthorisedStatsAccessError = UnauthorisedStatsAccessError;
//# sourceMappingURL=UnauthorisedStatsAccessError.js.map